export const INIT_APP = 'INIT_APP';
export const INIT_PROTOCOL = 'INIT_PROTOCOL';
export const UPDATE_BOTTOM_BUTTONS = 'UPDATE_BOTTOM_BUTTONS';
export const ENABLE_OVERFLOW_SCROLLING = 'ENABLE_OVERFLOW_SCROLLING';
export const HANDLE_CHAT_ROOM_CONNECTION = 'HANDLE_CHAT_ROOM_CONNECTION';
export const OPEN_MODAL_DIALOG = 'OPEN_MODAL_DIALOG';
export const CLOSE_MODAL_DIALOG = 'CLOSE_MODAL_DIALOG';
export const SHOW_WAIT_MESSAGE = 'SHOW_WAIT_MESSAGE';
export const HIDE_WAIT_MESSAGE = 'HIDE_WAIT_MESSAGE';
export const START_WAIT_MESSAGE_TIMER = 'START_WAIT_MESSAGE_TIMER';
export const CANCEL_WAIT_MESSAGE_TIMER = 'CANCEL_WAIT_MESSAGE_TIMER';
export const SET_DEFAULT_SYSTEM_MESSAGES = 'SET_DEFAULT_SYSTEM_MESSAGES';
export const UPDATE_SYSTEM_MESSAGES = 'UPDATE_SYSTEM_MESSAGES';
export const UPDATE_TITLE = 'UPDATE_TITLE';
export const UPDATE_PLACEHOLDER = 'UPDATE_PLACEHOLDER';

export const initProtocol = (protocol) => ({
  type: INIT_PROTOCOL,
  protocol
});

export const enableOverflowScrolling = () => ({
  type: ENABLE_OVERFLOW_SCROLLING
});

export const handleChatRoomConnection = action => ({
  type: HANDLE_CHAT_ROOM_CONNECTION,
  isChatRoomConnected: action === 'Access'
});

export const initApp = (option) => ({
  type: INIT_APP,
  ...option
});

export const updateBottomButtons = (data) => ({
  type: UPDATE_BOTTOM_BUTTONS,
  data
});

export const openModalDialog = (message) => ({
  type: OPEN_MODAL_DIALOG,
  message
});

export const closeModalDialog = () => ({
  type: CLOSE_MODAL_DIALOG
});

export const showWaitMessage = () => ({
  type: SHOW_WAIT_MESSAGE
});

export const hideWaitMessage = () => ({
  type: HIDE_WAIT_MESSAGE
});

export const startWaitMessageTimer = () => (dispatch, getState) => {
  const {
    chatRoot: {
      waitMessageTimeout
    }
  } = getState();

  const id = window.setTimeout(() => {
    dispatch(showWaitMessage());
  }, waitMessageTimeout);

  dispatch({
    type: START_WAIT_MESSAGE_TIMER,
    id: id
  });
};

export const cancelWaitMessageTimer = () => (dispatch, getState) => {
  const {
    chatRoot: {
      waitMessageTimerId
    }
  } = getState();

  window.clearTimeout(waitMessageTimerId);

  dispatch({
    type: CANCEL_WAIT_MESSAGE_TIMER
  });
};

export const setDefaultSystemMessages = () => (dispatch) => {
  dispatch({
    type: SET_DEFAULT_SYSTEM_MESSAGES,
  });
};

export const updateSystemMessages = (systemMessages) => (dispatch) => {
  dispatch({
    type: UPDATE_SYSTEM_MESSAGES,
    systemMessages
  });
};

export const updateTitle = (title) => (dispatch) => {
  dispatch({
    type: UPDATE_TITLE,
    title
  });
};

export const updatePlaceholder = (placeholder) => (dispatch) => {
  dispatch({
    type: UPDATE_PLACEHOLDER,
    placeholder
  })
}
